import { useEffect, useState } from 'react';
import { polyglot, changeLocale } from 'UTILS/locales';

/**
 * Add available translations and subscribe to locale changes.
 * @param translations
 * @returns {[translate, changeLocale]} A function to get the translation for a given key, and a function to globally change the current locale.
 */
const useTranslator = (translations) => {
  if (!polyglot) {
    throw new Error('translator_not_initialized');
  }
  const translatorId = translations?._id;
  if (translatorId == null) {
    throw new Error('translator_id_undefined');
  }

  const [locale, setLocale] = useState(polyglot.locale());
  if (translations) {
    polyglot.extend({ [translatorId]: translations[locale] });
  }

  useEffect(() => {
    const handleLanguageChange = ({ detail: newLocale }) => {
      polyglot.extend({ [translatorId]: translations[newLocale] });
      setLocale(newLocale);
    };
    document.addEventListener('locale_change', handleLanguageChange);
    return () => {
      document.removeEventListener('locale_change', handleLanguageChange);
    };
  }, []);

  return [(key, ...otherParams) => polyglot.t(`${translatorId}.${key}`, ...otherParams), changeLocale];
};

export default useTranslator;
